//@ts-ignore
import {GetStaticProps} from "next";
import HeaderImageWithHeading from "../../components/common/HeaderImageWithHeading";
import {MarkdownMetaDataInterface} from "../../interfaces/MarkdownMetaDataInterface";
import {getStaticPropsForMarkdownPage} from "../../helpers/GetStaticPropsForMarkdownPage";
import SimpleMarkdownRenderer from "../../components/common/SimpleMarkdownRenderer";
import ContactUsPanel from "../../components/ContactUsPanel/ContactUsPanel";
import {getSafeLocale} from "../../helpers/LocalizeObject";

function Page({result, markdown: MDXFile}: { result: MarkdownMetaDataInterface; markdown: any }) {
	return (
		<div className="">
			<HeaderImageWithHeading
				imageSrc={result.metadata.metadata.image}
				title={result.metadata.metadata.title}
				subtitle={result.metadata.metadata.subtitle}
			/>
			<div className="container mx-auto">
				<div className="px-6 md:px-20 my-20">
					<SimpleMarkdownRenderer mdxFile={MDXFile}/>
				</div>
				<ContactUsPanel image={result.metadata.metadata.contactImage}/>
			</div>
		</div>
	);
}

export const getStaticProps: GetStaticProps = async (context) => {
	const leistung = context.params?.leistung as string;
	const props = getStaticPropsForMarkdownPage(getSafeLocale(context.locale)!, leistung);
	return props;
};

export const LEISTUNGEN_CONTENT_PAGES = [
	{params: {leistung: "immobilienverwaltung"}},
	{params: {leistung: "poolpflege"}},
	{params: {leistung: "gartenpflege"}},
	//{ params: { leistung: "weitere-leistungen" } },
];

export async function getStaticPaths() {
	return {
		paths: LEISTUNGEN_CONTENT_PAGES,
		fallback: "blocking", // can also be true or 'blocking'
	};
}

export default Page;
